import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { format, parseISO } from "date-fns";
import { useCallback, useState } from "react";
import { useQuery } from "react-query";
import { Autocomplete } from "../../components/Autocomplete";
import { Table } from "../../components/Table";
import { listAnswers } from "../../services/answers";
import { listCampaignWithAnswers } from "../../services/campaigns";
import { useStyles } from "./styles";

export function Answers() {
  const styles = useStyles();
  const [campaignSelected, setCampaignSelected] = useState<number>();
  const [phone, setPhone] = useState<string>();
  const campaignsWithAnswers = useQuery(
    "campaignsWithAnswers",
    listCampaignWithAnswers
  );
  const answers = useQuery(
    ["answers", campaignSelected, phone],
    async () => await listAnswers(campaignSelected as number, phone),
    { enabled: Boolean(campaignSelected) || Boolean(phone) }
  );

  const handleChange = useCallback((_: any, campaign: any) => {
    setCampaignSelected(campaign.id_campanha);
  }, []);

  return (
    <>
      <div className={styles.root}>
        <Typography variant="h4">Respostas</Typography>
        <Typography variant="body2">
          Selecione uma campanha para listar as respostas.
        </Typography>
      </div>

      <div className={styles.rootActions}>
        <Autocomplete
          fullWidth
          label="Campanhas"
          loading={campaignsWithAnswers.isLoading}
          options={campaignsWithAnswers.data}
          getOptionLabel={(option) => option.nome_campanha}
          onChange={handleChange}
        />
        <TextField
          className={styles.inputPhone}
          variant="outlined"
          label="Destinatário"
          onChange={({ target: { value } }) => setPhone(value)}
        />
      </div>
      <Paper variant="outlined" elevation={0} className={styles.paper}>
        <Table
          toolbar={false}
          data={answers.data as []}
          isLoading={answers.isFetching}
          columns={[
            { title: "#", field: "id_campanha_envio" },
            { title: "Nome", field: "nome_pessoa" },
            { title: "Documento", field: "documento" },
            { title: "Destinatário", field: "destinatario" },
            { title: "Resposta", field: "resposta" },
            {
              title: "Data de recebimento",
              field: "data_recebimento",
              render: (row) =>
                format(
                  parseISO(row.data_recebimento?.replace("Z", "")),
                  "dd/MM/yyyy HH:mm"
                ),
            },
          ]}
          options={{
            actionsColumnIndex: -1,
            pageSize: 5,
            selectionProps: () => ({
              color: "primary",
            }),
          }}
          style={{ backgroundColor: "transparent" }}
          headerStyle={{ backgroundColor: "transparent" }}
        />
      </Paper>
    </>
  );
}
